module.exports = __webpack_public_path__ + "img/11手机.6120de96.png";